import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _NationalizationProcessItems } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectTHConstantsValue } from "../../../../config/Componentes/SelectTHConstantsValue";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { TaxPositionEditor } from "../NationalizationProcessGeneralInfo/TaxPosition/TaxPositionEditor";

interface Props {
    IDNationalizationProcessGeneralInfo: number;
}


export const NationalizationProcessItemsBydescarguedirecto = ({ IDNationalizationProcessGeneralInfo }: Props) => {

    const NationalizationProcessItemsBystudyCost = useDataBean(_NationalizationProcessItems);
    const single = Singleton.getInstance();
    const [Type, setType] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDNationalizationProcessGeneralInfo])

    const getLista = () => {

        NationalizationProcessItemsBystudyCost.instance.getNationalizationProcessItemsRender( IDNationalizationProcessGeneralInfo).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const create = () => {
        NationalizationProcessItemsBystudyCost.setBean({
            IDNationalizationProcessGeneralInfo: IDNationalizationProcessGeneralInfo,
            ItemType: NationalizationProcessItemsBystudyCost.bean.ItemType,
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        NationalizationProcessItemsBystudyCost.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }



    const editaItem = () => {
        //console.log(entailment.bean);
        NationalizationProcessItemsBystudyCost.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDNationalizationProcessItems', visible: true },
        // { title: 'Tipo de  Item / Lote', property: 'ItemType', visible: true },
        // { title: 'No.Consecutivo de registro', property: 'Item', visible: true },
        { title: 'Lote', property: 'LoteNumber', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Parte número', property: 'PartNoEDD', visible: true },
        { title: 'Número de serie', property: 'SerialNoEDD', visible: true },
        { title: 'Valor FOB Total', property: 'TotalFobValueEDD', visible: true },
        { title: 'Valor de fletes y seguros', property: 'TotalTransportInsuranceValueEDD', visible: true },
        { title: 'Valor total CIF', property: 'TotalCIFValueEDD', visible: true },
        { title: 'Valor total en Pesos', property: 'TotalValueInCOP', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "name": `Editar ${NationalizationProcessItemsBystudyCost.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <BasicPage titulo="Items">
            <div className="row">
                {/* <div className="col-md-6">
                    <label>Tipo de  Item / Lote</label>
                    <SelectTHConstantsValue code={602} value={Type} onChange={(e: any) => { setType(e) }}></SelectTHConstantsValue>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={getLista}>Buscar por Item / Lote</BasicButton>
                </div> */}
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={NationalizationProcessItemsBystudyCost.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            {/* <div className="col-md-12">
                                <label>Tipo de  Item / Lote</label>
                                <SelectTHConstantsValue code={602} value={NationalizationProcessItemsBystudyCost.bean.ItemType} onChange={(e: any) => { NationalizationProcessItemsBystudyCost.setBean({ ...NationalizationProcessItemsBystudyCost.bean, "ItemType": e }) }}></SelectTHConstantsValue>
                            </div> */}
                            {/* <div className="col-md-6">

                                <label>No.Consecutivo de registro item</label>
                                <input type="text" name="Item" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.Item} onChange={NationalizationProcessItemsBystudyCost.handleChange} />

                            </div> */}
                            <div className="col-md-6">

                                <label>No. Lote</label>
                                <input type="text" name="LoteNumber" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.LoteNumber} onChange={NationalizationProcessItemsBystudyCost.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Cantidad</label>
                                <input type="text" name="Quantity" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.Quantity} onChange={NationalizationProcessItemsBystudyCost.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Parte número</label>
                                <input type="text" name="PartNoEDD" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.PartNoEDD} onChange={NationalizationProcessItemsBystudyCost.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Número de serie</label>
                                <input type="text" name="SerialNoEDD" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.SerialNoEDD} onChange={NationalizationProcessItemsBystudyCost.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor FOB Total</label>
                                <input type="text" name="TotalFobValueEDD" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.TotalFobValueEDD} onChange={NationalizationProcessItemsBystudyCost.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor de fletes y seguros</label>
                                <input type="text" name="TotalTransportInsuranceValueEDD" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.TotalTransportInsuranceValueEDD} onChange={NationalizationProcessItemsBystudyCost.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor total CIF</label>
                                <input type="text" name="TotalCIFValueEDD" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.TotalCIFValueEDD} onChange={NationalizationProcessItemsBystudyCost.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor total en Pesos</label>
                                <input type="text" name="TotalValueInCOP" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.TotalValueInCOP} onChange={NationalizationProcessItemsBystudyCost.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={NationalizationProcessItemsBystudyCost.bean.Description} onChange={NationalizationProcessItemsBystudyCost.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {NationalizationProcessItemsBystudyCost.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}